import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";

const sendMessage = createAsyncThunk(
  "paymentNoticeDetail/sendMessage",
  async (arg, { getState, rejectWithValue, dispatch }) => {
    try {
      const state = getState() as RootState;
      const { text, archives } = state.paymentNoticeDetail.itemMessageFormData || {};
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      let response = await fetch(`${api.baseURL}message`, {
        method: "POST",
        body: JSON.stringify({
          text,
          attachmentArchives: archives.map((item) => item.id),
          room: state.paymentNoticeDetail.paymentNotice.id,
          createdBy: state.userAuthentication.user?.id,
        }),
        headers: headers,
      });
      if (!response.ok) {
        throw response.statusText;
      }
      let messageCreated = await response.json();
      return messageCreated;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export default sendMessage;
